var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _class, _temp2;

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

import React, { Component } from 'react';
import moment from 'moment';

import { getCalendar, Button } from '../';
import NavCalendarTable from './NavCalendarTable';

import './NavCalendar.scss';

var NavCalendar = (_temp2 = _class = function (_Component) {
    _inherits(NavCalendar, _Component);

    function NavCalendar() {
        var _temp, _this, _ret;

        _classCallCheck(this, NavCalendar);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
        }

        return _ret = (_temp = (_this = _possibleConstructorReturn(this, _Component.call.apply(_Component, [this].concat(args))), _this), _this.renderHeader = function () {
            var _this$props = _this.props,
                root = _this$props.root,
                date = _this$props.date;


            var prevMonth = moment(date).subtract(1, 'month').startOf('month');
            var nextMonth = moment(date).add(1, 'month').startOf('month');

            var prevMonthUrl = root + "/" + moment(prevMonth).format('YYYY/MM/DD');
            var nextMonthUrl = root + "/" + moment(nextMonth).format('YYYY/MM/DD');

            var prevMonthLabel = moment(prevMonth).format('MMMM');
            var nextMonthLabel = moment(nextMonth).format('MMMM');

            var caption = moment(date).format('MMMM YYYY');

            return React.createElement(
                'header',
                { className: 'nav-calendar__header' },
                React.createElement(
                    'h2',
                    { className: 'nav-calendar__title' },
                    caption
                ),
                React.createElement(
                    'nav',
                    { className: 'nav-calendar__pages' },
                    React.createElement(Button, { type: 'prev', root: prevMonthUrl, label: prevMonthLabel }),
                    React.createElement(Button, { type: 'next', root: nextMonthUrl, label: nextMonthLabel })
                )
            );
        }, _temp), _possibleConstructorReturn(_this, _ret);
    }

    NavCalendar.prototype.render = function render() {
        var _props = this.props,
            date = _props.date,
            items = _props.items;

        var calendar = getCalendar(date, items);

        var rows = calendar.rows;


        return React.createElement(
            'nav',
            { className: 'nav-calendar' },
            this.renderHeader(),
            React.createElement(NavCalendarTable, _extends({}, this.props, { rows: rows }))
        );
    };

    return NavCalendar;
}(Component), _class.defaultProps = {
    root: '',
    date: undefined
}, _temp2);


export default NavCalendar;